import React, { useState } from "react";
import PageTitle from "components/PageTitle/PageTitle";
import {
  Button,
  CircularProgress,
  Grid,
  TextareaAutosize,
  TextField,
} from "@material-ui/core";
import { Typography } from "components/Wrappers/Wrappers";

import routes from "routes";
import logo from "images/logoPagesRS.jpg";

import useStyles from "../styles";
import CustomizedSnackbars from "components/CustomizedSnackbars/CustomizedSnackbars";
import { SnackbarHandler } from "components/Handlers/SnackbarHandler";
import { dbGet, dbPut } from "utils/DBFetchers";
import { useHistory } from "react-router-dom";
import Field from "components/CustomFields/Field";

const blankEditRoleForm = {
  id: "",
  name: "",
  permissions: "",
};

export default function RolesEditPage(props) {
  var classes = useStyles();
  const history = useHistory();
  const [snackbarStatus, snackbarOpen, onCloseSnackbar] = SnackbarHandler();
  const [editRoleForm, updateForm] = useState(blankEditRoleForm);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    updateForm({
      ...editRoleForm,
      [e.target.name]: e.target.value,
    });
  };

  React.useEffect(() => {
    if (props?.props?.location?.state) {
      var roleId = props.props.location.state.roleId;
      dbGet(`roles/${roleId}`)
        .then((data) => {
          updateForm({
            ...editRoleForm,
            id: roleId,
            name: data.name ? data.name : "",
            permissions: data.permissions ? data.permissions : "",
          });
        })
        .catch((error) => {
          snackbarOpen("error", "Error al obtener el rol");
          setIsLoading(false);
        });
    }
  }, []);

  /* Submit handling */
  const handleSubmit = () => {
    setIsLoading(true);
    // Give adecuate format to send form to db
    var permissions =
      typeof editRoleForm.permissions === "string"
        ? editRoleForm.permissions.replace(/\s/g, "").split(",")
        : editRoleForm.permissions;

    let completedForm = {
      name: editRoleForm.name,
      permissions: permissions,
    };

    // Sends to db
    dbPut(`roles/${editRoleForm.id}`, completedForm)
      .then((data) => {
        snackbarOpen("success", "Rol editado exitosamente");
        history.push(routes.usersRoles);
      })
      .catch((error) => {
        snackbarOpen(
          "error",
          error[0] ? error[0].description_es : "Error al editar el rol",
        );
        setIsLoading(false);
        return;
      });
  };

  /* Cancel editing role and go one page backwards */
  const cancelAndGoBack = () => {
    updateForm(blankEditRoleForm);
    history.goBack();
  };

  return (
    <>
      <div>
        <PageTitle
          title="Editar rol"
          // button={
          //   <img src={logo} alt="logo" className={classes.logotypeImage} />
          // }
        />
      </div>
      <CustomizedSnackbars
        severity={snackbarStatus.severity}
        mssg={snackbarStatus.message}
        open={snackbarStatus.open}
        onClose={onCloseSnackbar}
      />
      <Grid
        style={{ display: "flex", margin: 0 }}
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
        spacing={4}
      >
        <form autoComplete="off">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h5" className={classes.text}>
                Datos del rol
              </Typography>
              <div
                className={classes.text}
                style={{
                  marginTop: "1%",
                  display: "flex",
                  justifyContent: "space-between",
                  width: 700,
                }}
              >
                <Typography weight="medium">
                  A continuación edite los datos del rol.
                </Typography>
              </div>

              <Field
                labelName="Nombre"
                required={true}
                id="name"
                value={editRoleForm.name}
                divClassType={classes.generalPurposeItems}
                fieldClassType={classes.generalPurposeField}
                onChange={handleChange}
              />

              <div
                className={classes.generalPurposeItems}
                style={{ marginTop: "4%" }}
              >
                <Typography className={classes.text} weight="bold">
                  Permisos
                </Typography>
                <TextField
                  labelName="Permisos"
                  multiline
                  minRows="4"
                  required={true}
                  id="permissions"
                  name="permissions"
                  variant="outlined"
                  margin="dense"
                  defaultValue={editRoleForm.permissions}
                  className={classes.generalPurposeField}
                  fullwidth={true}
                  onChange={handleChange}
                />
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={10}>
            <Grid item xs={12}>
              <div className={classes.buttonSpacing}>
                {isLoading ? (
                  <CircularProgress size={26} className={classes.loginLoader} />
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                  >
                    Guardar
                  </Button>
                )}
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={cancelAndGoBack}
                >
                  Cancelar
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </>
  );
}
